import { navigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'
import { gql, useMutation } from '@apollo/client'
import { formsClient } from '../../../../utils/apollo/api'

import { useLocation } from '../../../../utils/contexts/UrlProvider'

const MUTATION = gql`
  mutation InsertFormSend($input: FormSendInput) {
    insertFormSend(input: $input) {
      id
    }
  }
`

export const useSendFormRequest = (form, onSuccess) => {
  const { pathname } = useLocation()
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, {
    client: formsClient
  })

  const handleRequest = () => {
    return request({
      variables: { input: { fieldId: form.placeField.id, formId: Number(form.form.id), placeIds: form.places } }
    }).then(resp => {
      if (!resp.errors) {
        notify.success({
          title: `${form.form.name} enviado!`,
          message: `Formulário foi enviado para ${form.places.length} emails`
        })

        navigate(pathname)
        if (onSuccess) onSuccess(resp)
      } else {
        notify.error({ title: 'Ocorreu um erro ao enviar o formulário!' })
      }
    })
  }

  return [handleRequest, state]
}
